var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogo2Color(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 376,
    height: 450,
    viewBox: "0 0 376 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Alt_4_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 450
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alt_4_1",
    "data-name": "Alt 4 \\u2013 1",
    clipPath: "url(#clip-Alt_4_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 450,
    fill: "#8f00ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(7.958 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M6637.279,1749.429V1711.48c0-9.356-16.367-27.084-28.186-27.084H6569.57c-13.417,0-31.335-17.793-31.335-17.793h18.738s5.984,7.558,12.6,7.558,22.99.2,41.1,0,35.587,17.793,35.9,31.65,0,28.658,0,28.658Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M6549.682,1803.2s58.27-34.1,60.656-35.872,19.1-23.293,19.1-23.293v14.349s-15.185,17.887-17.051,19.753-24.868,14.775-29.164,16.492S6549.682,1803.2,6549.682,1803.2Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M6617.79,1834.32c.279-.186,17.331-21.057,17.331-21.057s23.666-13.883,27.766-19.846,14.722-19.474,14.722-19.474-.373,13.51-5.59,23.014S6617.79,1834.32,6617.79,1834.32Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M6617.79,1887.709l26.782,1.768,9.836-32.05V1844.01Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M6664.744,1870.938v19.355l-12.6,13.672-13.671-3.072Z",
    transform: "translate(-6511.932 -1530.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M6604.561,1756.427l-25.9,13.97h-31.021l13.1-13.97Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M6575.1,1756.427l-28.1,14.058h-19.77l11.96-14.058Z",
    transform: "translate(-6502.592 -1523.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M6611.825,1666.6s-74.079-44.008-78.391-49.8-2.36,19.313,8.513,25.184,42.044,24.611,42.044,24.611Z",
    transform: "translate(-6502.592 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M6627.6,1666.811c-18.9-11.061-27.095-21.283-40.928-31.924s-33.98-22.556-47.175-33.631-13.385-29.761-11.18-24.407,99.161,68.55,106.918,74.638,10.55,17.951,10.55,17.951l1.417,15.9S6646.5,1677.872,6627.6,1666.811Z",
    transform: "translate(-6502.095 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M6939.312,2024.773l42.69-61.513-19.213,10.979-41.978,46.66Z",
    transform: "translate(-6868.278 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M6971.024,2027.894l43.592-49.3,9.042-19.536-51.181,28.416-24.541,39.717Z",
    transform: "translate(-6868.278 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M6879.986,1986.927l30.6,10.1,103.685-60.3,29.468-35.744v-49.932L7020,1811.482s3.275,67.4-11.459,91.133S6879.986,1986.927,6879.986,1986.927Z",
    transform: "translate(-6868.278 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M6994.96,1853.086s-7.466-21-21.694-21h-45.4l33.7,21Z",
    transform: "translate(-6868.278 -1684.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M7045.654,1938.142l-17.408,28.732v71.3l13.834,31.215Z",
    transform: "translate(-6868.278 -1688.505)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(171.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85-2",
    "data-name": "Path 85",
    d: "M6547.665,1749.429V1711.48c0-9.356,16.367-27.084,28.186-27.084h39.523c13.417,0,31.335-17.793,31.335-17.793h-18.738s-5.984,7.558-12.6,7.558-22.99.2-41.1,0-35.587,17.793-35.9,31.65,0,28.658,0,28.658Z",
    transform: "translate(-6493.562 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M6629.439,1803.2s-58.27-34.1-60.656-35.872-19.1-23.293-19.1-23.293v14.349s15.185,17.887,17.051,19.753,24.868,14.775,29.164,16.492S6629.439,1803.2,6629.439,1803.2Z",
    transform: "translate(-6487.618 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M6677.608,1834.32c-.279-.186-17.331-21.057-17.331-21.057s-23.666-13.883-27.766-19.846-14.722-19.474-14.722-19.474.373,13.51,5.59,23.014S6677.608,1834.32,6677.608,1834.32Z",
    transform: "translate(-6603.723 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97-2",
    "data-name": "Path 97",
    d: "M6654.407,1887.709l-26.782,1.768-9.836-32.05V1844.01Z",
    transform: "translate(-6580.58 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M6638.475,1870.938v19.355l12.6,13.672,13.671-3.072Z",
    transform: "translate(-6602.204 -1530.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100-2",
    "data-name": "Path 100",
    d: "M6547.645,1756.427l25.9,13.97h31.021l-13.1-13.97Z",
    transform: "translate(-6460.734 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    d: "M6527.227,1756.427l28.1,14.058h19.77l-11.96-14.058Z",
    transform: "translate(-6410.941 -1523.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    d: "M6531.306,1666.6s74.079-44.008,78.391-49.8,2.36,19.313-8.513,25.184-42.044,24.611-42.044,24.611Z",
    transform: "translate(-6451.748 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M6546.864,1666.811c18.9-11.061,27.095-21.283,40.928-31.924s33.98-22.556,47.175-33.631,13.385-29.761,11.18-24.407-99.161,68.55-106.918,74.638-10.55,17.951-10.55,17.951l-1.417,15.9S6527.959,1677.872,6546.864,1666.811Z",
    transform: "translate(-6483.578 -1548.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192-2",
    "data-name": "Path 192",
    d: "M6963.5,2024.773l-42.69-61.513,19.213,10.979L6982,2020.9Z",
    transform: "translate(-6845.631 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193-2",
    "data-name": "Path 193",
    d: "M7000.57,2027.894l-43.592-49.3-9.042-19.536,51.181,28.416,24.541,39.717Z",
    transform: "translate(-6914.232 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213-2",
    "data-name": "Path 213",
    d: "M7043.449,1986.927l-30.548,10.1-103.5-60.3-29.416-35.744v-49.932l23.7-39.564s-3.27,67.4,11.438,91.133S7043.449,1986.927,7043.449,1986.927Z",
    transform: "translate(-6866.365 -1688.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230-2",
    "data-name": "Path 230",
    d: "M6927.863,1853.086s7.466-21,21.694-21h45.4l-33.7,21Z",
    transform: "translate(-6865.612 -1684.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231-2",
    "data-name": "Path 231",
    d: "M7028.246,1938.142l17.408,28.732v71.3l-13.834,31.215Z",
    transform: "translate(-7016.539 -1688.505)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2Color);
export default __webpack_public_path__ + "static/media/logo2-color.3ecf00395f526761c3d5e30a6f6c04f7.svg";
export { ForwardRef as ReactComponent };